import Protected from "./Protected";
import LandingPage from "../../features/marketing/components/layout/LandingPage";
import { NavigationProvider } from "../../contexts/NavigationContext";
import LandingPageWrapper from "pages/LandingPage";

export const Auth = {
  element: (
    <NavigationProvider>
      <Protected />
    </NavigationProvider>
  ),

  children: [
    {
      element: <LandingPageWrapper />,
      path: "/",
      children: [
        {
          element: <LandingPage />,
          path: "/",
        }
      ],
    },
  ],
};
